import { useState } from 'react'

import { SunIcon, MoonIcon } from '@heroicons/react/20/solid'

import Sidebar from '../Sidebar'
import UsersList from './UsersList'
import ExtensionAnalytics from './ExtensionAnalytics'
import ExtensionErrors from './ExtensionErrors'

import { useDarkMode } from '../../context/DarkModeContext'
import { useSidebar } from '../../context/SidebarContext'

export default function AdminUsers() {
	const { isDarkMode, toggleDarkMode } = useDarkMode()
	const { sidebarWidth } = useSidebar()

	const [loading, setLoading] = useState(false)
	const [activeTab, setActiveTab] = useState('users')

	return (
		<>
			<div style={{ backgroundColor: isDarkMode ? '#1c2127' : '#ffffff' }}>
				<Sidebar />

				<div
					style={{
						paddingLeft: `${sidebarWidth}px`,
						transition: 'padding-left 300ms ease-in-out',
					}}
				>
				<div
					className="top-0 z-40 flex h-16 shrink-0 items-center gap-x-6 px-4 sm:px-6 lg:px-8"
					style={{ backgroundColor: isDarkMode ? '#1c2127' : '#ffffff' }}
				>
					<div className="flex items-center ml-auto">
						{isDarkMode ? (
							<SunIcon
								className="h-5 w-5 text-gray-300 hover:text-white cursor-pointer"
								aria-hidden="true"
								onClick={toggleDarkMode}
							/>
						) : (
							<MoonIcon
								className="h-5 w-5 text-gray-600 hover:text-gray-900 cursor-pointer"
								aria-hidden="true"
								onClick={toggleDarkMode}
							/>
						)}
					</div>
				</div>

			<div className="flex justify-center mt-4 mb-4 px-4">
				<div className={`p-1 rounded-lg flex gap-1 ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
					<button
						onClick={() => setActiveTab('users')}
						className={`px-4 md:px-6 py-2 rounded-md text-sm md:text-base font-medium transition-all ${
							activeTab === 'users'
								? 'bg-blue-600 text-white'
								: isDarkMode
									? 'text-gray-400 hover:text-white hover:bg-gray-700'
									: 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'
						}`}
					>
						Users
					</button>
					<button
						onClick={() => setActiveTab('extension')}
						className={`px-4 md:px-6 py-2 rounded-md text-sm md:text-base font-medium transition-all ${
							activeTab === 'extension'
								? 'bg-blue-600 text-white'
								: isDarkMode
									? 'text-gray-400 hover:text-white hover:bg-gray-700'
									: 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'
						}`}
					>
						Analytics
					</button>
					<button
						onClick={() => setActiveTab('errors')}
						className={`px-4 md:px-6 py-2 rounded-md text-sm md:text-base font-medium transition-all ${
							activeTab === 'errors'
								? 'bg-red-600 text-white'
								: isDarkMode
									? 'text-gray-400 hover:text-white hover:bg-gray-700'
									: 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'
						}`}
					>
						Errors
					</button>
				</div>
			</div>

				<main
					className={`overflow-hidden rounded-tl-lg ${
						isDarkMode ? 'bg-dark-color' : 'bg-white'
					} mx-auto max-w-screen-xl`}
				>
					{activeTab === 'users' && (
						<UsersList
							loading={loading}
							setLoading={setLoading}
							isDarkMode={isDarkMode}
						/>
					)}
					{activeTab === 'extension' && <ExtensionAnalytics isDarkMode={isDarkMode} />}
					{activeTab === 'errors' && <ExtensionErrors isDarkMode={isDarkMode} />}
				</main>
				</div>
			</div>
		</>
	)
}
